//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/TransientObject.js";
import "../no/ugmath.js";
let d=[[[0,"Color",1,0],[0,"FontStyle",1,0],[0,"ReferencePositionType",1,0],[0,"ScreenTextSize",1,0]],[[[],"Dispose",{},0,0],[["fontIndex","view","viewType","object","position"],"DisplayTemporaryAbsoluteGeometry",{},5,0],[["fontIndex","view","viewType","object","position"],"DisplayTemporaryScreenGeometry",{},5,0],[["fontIndex","view","viewType","object","position"],"DisplayTemporaryAbsRotScreenSizeGeometry",{},5,0],[["textString"],"AddTextString",{},1,0],[["glyphWidth","glyphHeight"],"GetAbsoluteTextSize",{},0,0],[["glyphWidth","glyphHeight"],"SetAbsoluteTextSize",{},2,0]],[]];
SPLM.Display.TransientText = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.TransientText";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.TransientText.ViewType = Object.freeze({
    "WorkViewOnly" : "WorkViewOnly", "AllActiveViews" : "AllActiveViews", "ViewOfLastCursor" : "ViewOfLastCursor", "AllViewsButDrawing" : "AllViewsButDrawing", "AllActiveMemberViews" : "AllActiveMemberViews", "FirstViewFound" : "FirstViewFound"});

SPLM.Display.TransientText.StandardTextRef = Object.freeze({
    "SystemDefault" : "SystemDefault", "BaselineStart" : "BaselineStart", "BaselineCenter" : "BaselineCenter", "BaselineEnd" : "BaselineEnd", "TopLeft" : "TopLeft", "TopCenter" : "TopCenter", "TopRight" : "TopRight", "MiddleLeft" : "MiddleLeft", "MiddleCenter" : "MiddleCenter", "MiddleRight" : "MiddleRight", "BottomLeft" : "BottomLeft", "BottomCenter" : "BottomCenter", "BottomRight" : "BottomRight"});

SPLM.Display.TransientText.TextSize = Object.freeze({
    "Small" : "Small", "Normal" : "Normal", "Medium" : "Medium", "Large" : "Large", "NumSizes" : "NumSizes"});

export default SPLM;